'use client';

import { Circle } from 'rc-progress';
import styled from 'styled-components';

import { cssVar, theme, Typography } from '@zoomit/zoomit-ds';

import { scoreColor } from '../../helpers/score';

type Props = {
  rate: string;
  className?: string;
};

const ReviewCircleProgress = (props: Props) => {
  const { rate } = props;

  return (
    <Root className={props.className}>
      <CircleProgress
        percent={+rate * 20}
        strokeColor={scoreColor(+rate)}
        strokeWidth={5}
        trailWidth={4}
        trailColor={cssVar(theme.grey6)}
      />
      <Typography tag="span" fontSize={1.6} fontWeight="bold" className="rate-value fa" lineHeight={1.8}>
        {rate === '0' ? '-' : rate}
      </Typography>
    </Root>
  );
};

export default ReviewCircleProgress;

const Root = styled.div`
  position: relative;
  display: flex;

  .rate-value {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

const CircleProgress = styled(Circle)`
  width: 4.4rem;
  height: 4.4rem;
`;
